// components/SkeletonCard.tsx
"use client";
import { Flex, Skeleton, SkeletonText } from "@chakra-ui/react";

const SkeletonCard = () => {
  return (
    <Flex direction="column" borderRadius="14px">
      <Skeleton
        overflow="hidden"
        borderRadius="14px"
        minH={{ base: "142px", md: "180px", lg: "264px" }}
        w={{ base: "142px", md: "180px", lg: "264px" }}
      />
      <Flex align="center" mt="16px">
        <Flex ml="8px" direction="column">
          <SkeletonText mt="2" noOfLines={2} spacing="4" width="150px" />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SkeletonCard;
